import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubMenuCurriculumWrapper from "Administrator/commonComponents/SubMenuCurriculumWrapper";
import { getNextMenuRoute } from "Administrator/modules/AdministratorModule";
import { getRelativePath } from "Utils";
export default store => ({
  path: "classes",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-schoolSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "CourseSetup/modules/Module"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "CourseSetup/components/CreateCourse/containers/CreateCourseModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "CourseSetup/components/EditCourse/containers/CourseDetailsModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "CourseSetup/components/BulkActions/modules/BulkActionsModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
        ]) => {
          const component = importedModule0.default;
          const module2 = importedModule1;
          const CreateCourseModule = importedModule2;
          const courseDetailsModule = importedModule3;
          const courseBulkActionsModule = importedModule4;
          const reducer = module2.default;
          const key = module2.NAME;
          injectReducer(store, {
            key,
            reducer,
          });
          injectReducer(store, {
            key: CreateCourseModule.NAME,
            reducer: CreateCourseModule.default,
          });
          injectReducer(store, {
            key: courseDetailsModule.NAME,
            reducer: courseDetailsModule.default,
          });
          injectReducer(store, {
            key: courseBulkActionsModule.NAME,
            reducer: courseBulkActionsModule.default,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    if (_.last(nextState.routes).path == "classes") {
      const route = getNextMenuRoute("COURSE_SETUP");
      if (route) {
        replace(getRelativePath(route));
      } else {
        replace(getRelativePath("../"));
      }
    }
  },
  childRoutes: [SubMenuCurriculumWrapper(store)],
});
